// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"611951da","360":"8d2988d5","463":"92edf5cb","659":"81324359","939":"5864ac2b"}[chunkId] + ".css";
};